import { Cost, ErpPrice, PriceType } from "@tm/models"

export function getPrice(prices: Array<ErpPrice>, type: PriceType): ErpPrice | undefined {
    return prices.find((price) => price && price.type === type)
}

export function mapCostsToPrices(costs?: Cost[]): ErpPrice[] {
    if (!costs) {
        return []
    }
    return costs.map((cost) => {
        return {
            type: PriceType.None,
            description: cost.description,
            currencyCode_Iso_4217: cost.currencyCode,
            value: cost.value,
            currencySymbol: cost.currencySymbol,
            vat: cost.vat ?? 0,
            shortDescription: cost.shortDescription,
        }
    })
}
